<template lang="pug">
.generic-wrapper
  .container
    BackButton(name="ListsOverview")
    h1.title Alle Buchungen
    .sub-headline Hier sehen Sie die neusten 200 Buchungen mit vorhandener Mietvertragsnummer.

  .card.margin-top
    .top
      label Filter
      .spacer.sm
      .button-wrapper
        b-field(label="Miet-V." label-position="on-border")
          b-input(v-model="filter.parentContractId")
        b-field(label="Code" label-position="on-border")
          b-input(v-model="filter.code")
        b-field(label="Nachname" label-position="on-border")
          b-input(v-model="filter.lastName")
        b-button(@click="filterBookings") Filtern
    .main
      b-table(:data="bookingsPlus"
              default-sort-direction="desc"
              default-sort="parentContractId"
              hoverable
              @click="row => jumpToBookingInCalendar(row)")
        b-table-column(field='parentContractId' label='Miet-V.' sortable v-slot="props")
          | \#{{props.row.parentContractId}}
        b-table-column(field='createdAt' label='Buchungsdatum' sortable v-slot="props")
          | {{formatDate(props.row.parentContract.createdAt)}}
        b-table-column(field='rentObject.code' label='Code' sortable v-slot="props")
          | {{props.row.rentObject.code}}
        b-table-column(field='rentObject.name' label='Objekt' sortable v-slot="props")
          | {{props.row.rentObject.name}}
        b-table-column(field='customer.lastName' label='Nachname' sortable v-slot="props")
          div(v-if="props.row.bookingStatus.uuid === 'STATUS_BOOKING_PERSONAL'") {{props.row.rentObject.owner.fullName}}
          div(v-else) {{props.row.customer ? props.row.customer.lastName : '-'}}
        b-table-column(field='startDate' label='Anreise' sortable v-slot="props" width="120")
          | {{formatDate(props.row.startDate)}}
        b-table-column(field='endDate' label='Abreise' sortable v-slot="props" width="120")
          | {{formatDate(props.row.endDate)}}
        b-table-column(label='Nächte' sortable v-slot="props" width="120")
          | {{dateDiff(props.row.startDate, props.row.endDate)}}
        b-table-column(field='adults' label='Erw.' sortable v-slot="props")
          | {{props.row.adults}}
        b-table-column(field='children' label='Kin.' sortable v-slot="props")
          | {{props.row.children}}
        b-table-column(label='Miete gesamt' numeric v-slot="props")
          div(v-if="!props.row.parentContract") -
          div(v-else) {{props.row.parentContract.contracts[props.row.parentContract.contracts.length-1].totalPrice/100 | toCurrency}}
        b-table-column(label='Status' v-slot="props")
          .is-deleted(v-if="props.row.deletedAt")
            b-button(icon-left="auto-fix" size="is-small" type="is-danger" @click.stop="restoreBooking(props.row)") Wiederherstellen
          .status-selection
            .color-box(:style="{backgroundColor: props.row.bookingStatus.colorCode}")
            |{{props.row.bookingStatus.name}}
</template>

<script>
import { DateTime } from 'luxon';

export default {
  data() {
    return {
      bookings: [],
      filter: {
        parentContractId: null,
        code: null,
        lastName: null,
      }
    };
  },
  computed: {
    bookingsPlus() {
      return this.bookings.map(a => {
        let payments = 0;
        a.payments.forEach(element => {
          payments += element.total;
        });
        return {
          ...a,
          payments
        }
      });
    }
  },
  async mounted() {
    const loadingComponent = this.$buefy.loading.open();
    this.bookings = await this.$store.dispatch("rentObjectBookings/findAllBookings", this.filter);
    loadingComponent.close();
  },
  methods: {
    async filterBookings() {
      this.bookings = await this.$store.dispatch("rentObjectBookings/findAllBookings", this.filter);
    },
    formatDate(d) {
      const dt = DateTime.fromISO(d);
      return dt.setLocale('de')
        .toFormat("dd.LL.yy")
    },
    dateDiff(start, end) {
      const dtStart = DateTime.fromISO(start);
      const dtEnd = DateTime.fromISO(end);
      return Math.ceil(dtEnd.diff(dtStart, 'day').toObject().days);
    },
    jumpToBookingInCalendar(booking) {
      this.$router.push({name: 'BookingCalendar', query: {jumpDate: DateTime.fromISO(booking.startDate).toHTTP(), jumpObjectId: booking.rentObjectId, bookingStatusId: booking.bookingStatusId}})
    },
    async restoreBooking(b) {
      this.$buefy.dialog.confirm({
        title: "Buchung wiederherstellen",
        message: `Sind Sie sicher, dass Sie die Buchung von <b>${b.customer.firstName ?? ''} ${b.customer.lastName}</b> wiederherstellen möchten?`,
        confirmText: "Buchung wiederherstellen",
        cancelText: "Abbrechen",
        type: "is-success",
        hasIcon: true,
        onConfirm: async () => {
          try {
            await this.$store.dispatch("rentObjectBookings/restore", { id: b.id });
            const loadingComponent = this.$buefy.loading.open();
            this.bookings = await this.$store.dispatch("rentObjectBookings/findAllBookings", this.filter);
            loadingComponent.close();
          } catch (e) {
            // handled in store
          }
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.edit-text {
  cursor: pointer;
  width: 100%;
  height: 100%;
}

.extra-table {
  font-size: 0.8rem;
  td {
    padding: 0;
  }
}

.status-selection {
    display: inline-block;
    font-size: 14px;
    margin-right: 4px;
    font-weight: 500;
    user-select: none;
    text-align: left;
    color: black !important;
    .color-box {
      height: 16px;
      width: 24px;
      border-radius: 99px;
      display: inline-block;
      margin-right: 3px;
    }
  }
</style>